export interface VersionItem {
  id: string;
  version: string;
  date: string;
  tag: string;
  size: string;
  changes: string[];
}

export const versions: VersionItem[] = [
  {
    id: "ver-321",
    version: "v3.2.1",
    date: "2026-09-18",
    tag: "当前版本",
    size: "42.6 MB（手机版）",
    changes: [
      "新增「近期更新」片单，追更剧集集中展示，减少翻找。",
      "优化 TV 端遥控操作焦点逻辑，方向键移动更顺滑。",
      "修复部分安卓机型在 4K 片源下偶发的音画不同步问题。",
      "提升弱网环境下的首帧加载速度，平均缩短约 20%。",
    ],
  },
  {
    id: "ver-320",
    version: "v3.2.0",
    date: "2026-08-06",
    tag: "功能更新",
    size: "41.8 MB（手机版）",
    changes: [
      "上线多端观看进度云同步，手机与电视之间无缝续播。",
      "新增离线缓存「仅 Wi-Fi 下载」开关，避免移动网络消耗。",
      "重做首页分类导航，支持一键切换电影、剧集、动漫等分区。",
      "新增青少年模式入口，可限制内容分级与观看时长。",
    ],
  },
  {
    id: "ver-318",
    version: "v3.1.8",
    date: "2026-06-21",
    tag: "体验优化",
    size: "40.3 MB（手机版）",
    changes: [
      "优化搜索联想，输入首字即可快速匹配影片。",
      "改进投屏稳定性，减少手机与电视断连的情况。",
      "修复描述文件方式安装在部分 iOS 版本上的信任提示异常。",
      "补充多语言字幕切换与字号调节选项。",
    ],
  },
];

export const versionNotes: { id: string; icon: string; title: string; desc: string }[] = [
  {
    id: "note-update",
    icon: "ri-loop-right-line",
    title: "更新方式",
    desc: "客户端内「设置 → 关于」可检测新版本；也可回到本页重新下载最新安装包覆盖安装。",
  },
  {
    id: "note-data",
    icon: "ri-database-2-line",
    title: "数据保留",
    desc: "覆盖安装不会清除收藏与观看记录，卸载重装前建议先登录账号完成同步。",
  },
  {
    id: "note-size",
    icon: "ri-scales-3-line",
    title: "体积说明",
    desc: "不同平台安装包体积略有差异，TV 版与手机版不可混用，请对应设备下载。",
  },
];